import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Typography, Grid, useTheme, Box, Divider, Chip } from '@mui/material';
import { tokens } from '../../../theme';
import { formattedDate, isEmpty } from '../../../Utils/Functions';
import MuiDialog from '../../../SystemDesign/MuiDialog';
import InfoIcon from '@mui/icons-material/Info';
import { DialogSection, DialogSectionLabel, DialogSectionValue } from '../../../SystemDesign/Styles';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';

const SeeMoreRater = ({ row }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const raterType = row.original;

  const sections = [
    {
      id: 'basic',
      title: 'Rater Type information',
      icon: <BadgeOutlinedIcon />,
      content: [
        { label: 'Name', value: raterType.name },
        { label: 'Description', value: raterType.description || '-' },
        { label: 'ID', value: raterType.id },
        { label: 'Created at', value: raterType.createdAt ? formattedDate(new Date(raterType.createdAt)) : '-' },
        { label: 'Updated at', value: raterType.updatedAt ? formattedDate(new Date(raterType.updatedAt)) : '-' },
      ]
    },
  ];

  const DetailItem = ({ label, value, chip, icon, multiline }) => (
    <Box sx={{ mb: 2, display: 'flex', alignItems: multiline ? 'flex-start' : 'center', gap: 0.5 }}>
      <Typography sx={DialogSectionLabel(colors)}>
        {icon && React.cloneElement(icon, { fontSize: 'small' })}
        {label} :
      </Typography>
      {chip ? (
        <Box sx={{ '& .MuiChip-root': { transition: 'all 0.2s', '&:hover': { opacity: 0.8 } } }}>
          {chip}
        </Box>
      ) : (
        <Typography sx={{
          ...DialogSectionValue(colors),
          ...(multiline && { whiteSpace: 'pre-wrap', maxWidth: '480px' })
        }}>
          {value || '-'}
        </Typography>
      )}
    </Box>
  );

  const SectionHeader = ({ title, icon }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', my: 2 }}>
      <Typography sx={{ ...DialogSection(colors), mr: 1 }}>
        {icon}{title}
      </Typography>
      <Divider sx={{ flexGrow: 1 }} />
    </Box>
  );

  const dialogContent = (
    <Grid container>
      {sections.map((section) => (
        <Grid item xs={12} key={section.id}>
          <SectionHeader title={section.title} icon={section.icon} />
          {section.content.map((item, index) => (
            <DetailItem key={index} {...item} />
          ))}
        </Grid>
      ))}
    </Grid>
  );

  const triggerButton = (
    <MenuItem>
      <ListItemIcon>
        <VisibilityIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>See more</ListItemText>
    </MenuItem>
  );

  return (
    <MuiDialog
      icon={<InfoIcon />}
      triggerButton={triggerButton}
      title="Rater Type details"
      subtitle={`Rater Type details ${raterType.name}`}
      content={dialogContent}
      existAction={false}
      maxWidth="sm"
    />
  );
};

export default SeeMoreRater;
